import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { CommunityPageHeader } from './CommunityPageHeader';
import { pageBackground } from '@client/new/pages/page-background.css';

export const CommunityLayout = ({
  children,
  ...p
}: {
  children: ReactNode;
  ownerName: string;
  communityId: number;
  postId?: string;
  influencerId: number;
}) => (
  <Box className={`${pageBackground} h-full`}>
    <CommunityPageHeader {...p} />
    {children}
  </Box>
);
